import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  subtext?: string;
  className?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  text,
  subtext,
  className = '',
  fullWidth = false
}: CTAButtonProps) {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <button onClick={scrollToPricing} className={`
        group relative inline-flex flex-col items-center justify-center 
        bg-[#8B4513] hover:bg-[#A0522D] text-white 
        py-3 px-6 rounded-lg shadow-md hover:shadow-lg hover:-translate-y-0.5 
        transition-all duration-300 ease-out border-b-2 border-[#6B3410]
        ${fullWidth ? 'w-full' : 'w-auto'}
        ${className}
      `} data-id="element-11">
      <div className="flex items-center gap-2 text-base md:text-lg font-bold uppercase tracking-wide text-center" data-id="element-12">
        {text}
        <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-13" />
      </div>
      {subtext && <span className="text-xs md:text-sm font-medium opacity-90 mt-1" data-id="element-14">
          {subtext}
        </span>}
    </button>;
}